import { gql } from "@apollo/client";

// Existing mutation
export const PROCESS_EQUIPMENT_REQUEST = gql`
    mutation processEquipmentRequest($id: Int!, $truck: Int!, $notes: String, $items: [ProcessEquipmentRequestItemInputType]!) {
        processEquipmentRequest(id: $id, truck: $truck, notes: $notes, items: $items) {
            equipmentRequest {
                id
            }
        }
    }
`

// ✅ New mutation for deleting an equipment request
export const DELETE_EQUIPMENT_REQUEST = gql`
    mutation deleteEquipmentRequest($id: Int!) {
        deleteEquipmentRequest(id: $id) {
            didDelete
        }
    }
`
